import React, {ReactElement} from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Funnel + × — “clear filters”, distinct from circular refresh/reload icons.
 */
const ClearFiltersIcon = (props: Record<string, unknown>): ReactElement => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M6 6h12l-5 8v6h-2v-6l-5-8H6z" />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        d="M15 15l4 4m0-4l-4 4"
      />
    </SvgIcon>
  );
};

export default ClearFiltersIcon;
